module.exports = __webpack_public_path__ + "static/img/icon_zaa.819cccc9.png";